import { DestroyRef, Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { ReportConfiguration } from '../../models/report-configuration';
import { ReportsResult } from '../../models/reports-reportsresult';
import { ReportsService } from '../../services/reports.service';
import { ReportsRunReportResultComponent } from '../../components/reports-run-report-result/reports-run-report-result.component';
import { ReportsRunReportConfigurationComponent } from '../reports-run-report-configuration/reports-run-report-configuration.component';

@Component({
    selector: 'app-reports-run-report',
    templateUrl: './reports-run-report.component.html',
    styleUrls: ['./reports-run-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReportsRunReportConfigurationComponent, ReportsRunReportResultComponent]
})
export class ReportsRunReportComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private readonly destroyRef = inject(DestroyRef);
    private readonly reportsService = inject(ReportsService);

    @ViewChild('resultPage', { static: true }) private resultPage!: ReportsRunReportResultComponent;

    reportId = 0;
    reportConfiguration: ReportConfiguration | null = null;

    ngOnInit(): void {
        this.route.paramMap.pipe(
            takeUntilDestroyed(this.destroyRef),
            map(paramMap => Number(paramMap.get('id')))
        ).subscribe(id => {
            this.reportId = id;
            void this.refresh(id);
        });
    }

    private async refresh(id?: number): Promise<void> {
        this.reportConfiguration = (await this.reportsService.getReportConfigurations(id))[0] ?? null;
    }

    onResultOutputReceived(reportResult: ReportsResult): void {
        this.resultPage.refreshGrid(reportResult);
    }
}
